module.exports = __webpack_public_path__ + "static/img/img_arcgis.8d084b37.png";